import React, { Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  MenuItem,
  Select,
  TextField,
  FormControl,
  InputLabel,
  FormHelperText,
  Switch,
  FormGroup,
  FormControlLabel,
} from "@mui/material";
import { Users } from "react-feather";
import { userRequest } from "../../../auth/requestMethods";
import { toast } from "react-toastify";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet-async';

const FormDefault = ({ history }) => {
  const path = useLocation().pathname.split("/")[3];
  const [activated, setAcitvated] = React.useState("INACTIVE");
  const [currentEmail, setCurrentEmail] = React.useState("");

  const {
    handleSubmit,
    watch,
    reset,
    trigger,
    register,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(userValidationSchema),
    defaultValues: defaultValues,
  });

  React.useEffect(() => {
    trigger();
    const subscription = watch((value, { name }) => {
      trigger(name);
    });
    return () => subscription.unsubscribe();
  }, [watch, trigger]);

  React.useEffect(() => {
    userRequest()
      .get(`/users/retrieve/${path}`)
      .then(({ data }) => {
        setAcitvated(data.user.status);
        reset(data.user);
        setCurrentEmail(data.user.email);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [path, reset]);

  const resendActivationLink = () => {
    toast.info("Sending...", {
      isLoading: true,
      position: "bottom-center",
      autoClose:5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      toastId: "updateUser",
      theme: "colored",
    });
    userRequest()
      .post("/users/send-link/" + path)
      .then(() => {
        toast.update("updateUser", {
          pauseOnFocusLoss: false,
          isLoading: false,
          autoClose:5000,
          type: "success",
          render: "Successfully sent",
        });
      })
      .catch(({ response }) => {
        toast.update("updateUser", {
          pauseOnFocusLoss: false,
          isLoading: false,
          autoClose:5000,
          type: "error",
          render: response?.data?.message || "Something went wrong",
        });
      });
  };

  const onSubmit = (data) => {
    if (data !== "") {
      toast.info("Updating...", {
        isLoading: true,
        position: "bottom-center",
        autoClose:5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        toastId: "updateUser",
        theme: "colored",
      });
      if (currentEmail === data.email) {
        delete data.email;
      }
      userRequest()
        .post("/users/update/" + path, data)
        .then(() => {
          toast.update("updateUser", {
            pauseOnFocusLoss: false,
            isLoading: false,
            autoClose:5000,
            type: "success",
            render: "Successfully updated",
          });
          history.push(`${process.env.PUBLIC_URL}/users/manage`);
        })
        .catch(({ response }) => {
          toast.update("updateUser", {
            pauseOnFocusLoss: false,
            isLoading: false,
            type: "error",
            autoClose:5000,
            render: response.data.message,
          });
        });
    } else {
      errors.showMessages();
    }
  };
  return (
      <Fragment>
      <Breadcrumb
        link="/users/manage"
        icon={<Users />}
        title= "Update"
        parent="User"
      />
      <Helmet>
        <title>PFSA | Users | Update</title>
      </Helmet>
      <div className="col-sm-12">
        <div className="card">
          <div className="card-header">
            <h5>Update User</h5>
          </div>
          <div className="card-body">
            <form className="theme-form" noValidate="" onSubmit={handleSubmit(onSubmit)}>
              <div className="form-group row">
                <TextField
                  value={watch("email")}
                  label="*Email"
                  variant="outlined"
                  {...register(`email`)}
                  helperText={errors.email?.message}
                  error={!!errors.email?.message}
                />
              </div>
              <div className="form-group row">
                <TextField
                  value={watch("name")}
                  label="*Name"
                  variant="outlined"
                  {...register(`name`)}
                  helperText={errors.name?.message}
                  error={!!errors.name?.message}
                />
              </div>
              <div className="form-group row">
                <TextField
                  value={watch("surname")}
                  label="*Surname"
                  variant="outlined"
                  {...register(`surname`)}
                  helperText={errors.surname?.message}
                  error={!!errors.surname?.message}
                />
              </div>
              <div className="form-group row">
                <Controller
                  control={control}
                  name="role"
                  defaultValue={0}
                  render={({ field }) => (
                    <FormControl error={!!errors.role?.message}>
                      <InputLabel id="demo-simple-select-helper-label">*Role</InputLabel>
                      <Select
                        name={field.name}
                        value={field.value}
                        onBlur={field.onBlur}
                        onChange={(e) => {
                          field.onChange(e.target.value);
                        }}
                        labelId="demo-simple-select-helper-label"
                        id="demo-simple-select-helper"
                        label="*Role"
                      >
                        <MenuItem value="">- Select -</MenuItem>
                        <MenuItem value="VIEWER">VIEWER</MenuItem>
                        <MenuItem value="APPLICATOR">APPLICATOR</MenuItem>
                        <MenuItem value="SUPERUSER">SUPERUSER</MenuItem>
                        <MenuItem value="ADMINISTRATOR">ADMINISTRATOR</MenuItem>
                      </Select>
                      {/* <FormHelperText>{errors.role?.message}</FormHelperText> */}
                    </FormControl>
                  )}
                />
              </div>
              {activated !== "ACTIVATED" && (
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Registration Status</label>
                  <label className="col-sm-2 col-form-label txt-warning">Pending</label>
                  <button className="btn-outline-success col-sm-2" type="button" onClick={resendActivationLink}>
                    Resend Activation Link
                  </button>
                </div>
              )}

              {
                activated === 'ACTIVATED' && (
                  <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Registration Status</label>
                  <label className="col-sm-2 col-form-label txt-success">Complete</label>
                </div>
                )
              }

              <div className="d-flex justify-content-start my-4">
                <FormGroup>
                  <FormControlLabel
                    control={<Switch {...register("is_active")} defaultChecked={watch("is_active")} />}
                    label="Active Status"
                    sx={{ margin: 0 }}
                    labelPlacement="start"
                  />
                </FormGroup>
              </div>
              <div>
                <button className="btn btn-primary me-1" type="submit">
                  Save
                </button>
                <Link to={`${process.env.PUBLIC_URL}/users/manage`}>
                  <button className="btn btn-secondary" type="button">
                    Cancel
                  </button>
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default FormDefault;

const defaultValues = {
  name: "",
  surname: "",
  email: "",
  is_active: true,
  role: "",
};

const userValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  surname: Yup.string().required("Surname is required"),
  email: Yup.string().email("Not a proper email").required("Email is required"),
  role: Yup.string().required("Role is required"),
  is_active: Yup.boolean().default(true),
});
